if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      async onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden'
        )

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        const variantId = formData.get('id')
        const regionPrice = formData.get('properties[_productPriceFor_RegionPrice]')
        
        // Validate and remove region price if it's empty or invalid
        // Note: Price comparison with product price will be done in cart processing
        if (regionPrice) {
          const regionPriceNum = parseFloat(regionPrice);
          // Remove from formData if invalid, empty, or zero
          if (!regionPrice || regionPrice.trim() === '' || isNaN(regionPriceNum) || regionPriceNum <= 0) {
            formData.delete('properties[_productPriceFor_RegionPrice]');
          }
        }
        
        // Check if same variant already exists in cart and update it instead of adding new
        const updatedRegionPrice = formData.get('properties[_productPriceFor_RegionPrice]');
        if (variantId && updatedRegionPrice) {
          try {
            const cartResponse = await fetch('/cart.js')
            const cartData = await cartResponse.json()
            
            // Find existing line item with same variant ID
            const existingItem = cartData.items.find(item => item.variant_id == variantId)
            
            if (existingItem) {
              // Start with existing properties to preserve them
              const properties = existingItem.properties ? { ...existingItem.properties } : {}
              
              // Calculate _isMetafieldPrice in cents (region price * 100)
              const regionPriceNum = parseFloat(updatedRegionPrice)
              // Validate: remove if equals original price or final price
              const regionPriceInCents = Math.round(regionPriceNum * 100);
              if (regionPriceInCents === existingItem.price || regionPriceInCents === existingItem.final_price) {
                // Remove the property if it equals product price
                formData.delete('properties[_productPriceFor_RegionPrice]');
                delete properties['_productPriceFor_RegionPrice'];
                delete properties['_isMetafieldPrice'];
              } else {
                const _isMetafieldPrice = regionPriceInCents;
              
                // Update with new form properties (this will override existing ones)
                for (const [key, value] of formData.entries()) {
                  if (key.startsWith('properties[') && key.endsWith(']')) {
                    const propName = key.slice(11, -1) // Extract property name
                    // Only set if value is not empty, and for _productPriceFor_RegionPrice, ensure it's a valid number
                    if (value && value.trim() !== '') {
                      // For _productPriceFor_RegionPrice, only add if it's a valid number
                      if (propName === '_productPriceFor_RegionPrice') {
                        const priceNum = parseFloat(value);
                        if (!isNaN(priceNum) && priceNum > 0) {
                          properties[propName] = value
                        } else {
                          // Remove the property if it's empty or invalid
                          delete properties[propName];
                        }
                      } else {
                        properties[propName] = value
                      }
                    } else if (propName === '_productPriceFor_RegionPrice') {
                      // Remove empty _productPriceFor_RegionPrice property
                      delete properties[propName];
                    }
                  }
                }
                
                // Ensure _isMetafieldPrice is set only if region price is valid (override with new value)
                if (updatedRegionPrice && updatedRegionPrice.trim() !== '') {
                  const priceNum = parseFloat(updatedRegionPrice);
                  if (!isNaN(priceNum) && priceNum > 0) {
                    properties._isMetafieldPrice = _isMetafieldPrice.toString()
                  } else {
                    delete properties._isMetafieldPrice;
                  }
                } else {
                  delete properties._isMetafieldPrice;
                }
              }
              
              // Update existing line item properties
              const updateConfig = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  id: existingItem.key,
                  properties: properties
                })
              }
              
              if (this.cart) {
                const sections = this.cart.getSectionsToRender().map((section) => section.id)
                updateConfig.body = JSON.stringify({
                  id: existingItem.key,
                  properties: properties,
                  sections: sections,
                  sections_url: window.location.pathname
                })
                this.cart.setActiveElement(document.activeElement)
              }
              
              const updateResponse = await fetch('/cart/change.js', updateConfig)
              const response = await updateResponse.json()
              
              // Handle response similar to add to cart
              const errorDiv = document.querySelector('.all_items_added_error_mesaage')
              if (errorDiv) errorDiv.innerText = ''
              
              if (response.status) {
                if (errorDiv) {
                  errorDiv.innerText += `⚠️ ${response.description}`
                  errorDiv.classList.remove('hidden')
                }
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                })
                this.handleErrorMessage(response.description)
                this.error = true
                return
              }
              
              if (!this.error && errorDiv) errorDiv.classList.add('hidden')
              
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              })
              this.error = false
              
              const quickAddModal = this.closest('quick-add-modal')
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response)
                    })
                  },
                  { once: true }
                )
                quickAddModal.hide(true)
              } else {
                this.cart.renderContents(response)
              }
              
              let checkAvaibility = document.querySelector('.product-cart-amc.selected')
              if (checkAvaibility) {
                document.querySelectorAll('#CartDrawer-Checkout').forEach(item => item.setAttribute('disabled', 'true'))
                customATCFunction(checkAvaibility.getAttribute('variant-id'))
              }
              
              // Cleanup
              this.submitButton.classList.remove('loading')
              if (this.cart && this.cart.classList.contains('is-empty'))
                this.cart.classList.remove('is-empty')
              if (!this.error) this.submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add('hidden')
              const gstValue = sessionStorage.getItem("customer_gst_value")
              if (gstValue) {
                const GSTinputElements = document.querySelectorAll('.customer_gst_value_input')
                GSTinputElements.forEach((element) => {
                  element.value = gstValue.trim()
                })
              }
              return
            }
          } catch (error) {
            console.error('Error checking/updating cart:', error)
            // Fall through to normal add to cart flow
          }
        }
        
        // Normal add to cart flow
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData
        const errorDiv = document.querySelector(
          '.all_items_added_error_mesaage'
        )

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
          if(errorDiv)  errorDiv.innerText = ''
            if (response.status) {
              if(errorDiv){
                errorDiv.innerText += `⚠️ ${response.description}`
                errorDiv.classList.remove('hidden')
              }
              
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })
              this.handleErrorMessage(response.description)

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButton.querySelector('span').classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            if (!this.error && errorDiv) errorDiv.classList.add('hidden')

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            })
            this.error = false
            const quickAddModal = this.closest('quick-add-modal')
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response)
                  })
                },
                { once: true }
              )
              quickAddModal.hide(true)
            } else {
              this.cart.renderContents(response)
            }
            let checkAvaibility = document.querySelector('.product-cart-amc.selected');
            if(checkAvaibility){
              document.querySelectorAll('#CartDrawer-Checkout').forEach(item=> item.setAttribute('disabled', 'true'))
              customATCFunction(checkAvaibility.getAttribute('variant-id'));
            }
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden'
            )
            const gstValue = sessionStorage.getItem("customer_gst_value")
            if(gstValue){
                const GSTinputElements = document.querySelectorAll('.customer_gst_value_input');
                GSTinputElements.forEach((element)=>{
                    element.value = gstValue.trim()
                  
                })
    
            }
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}
